'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    Authentication = require('services/Security').Authentication,
    NumberUtils = require('utils/NumberUtils'),
    BrewhouseStore = require('stores/BrewhouseStore'),
    AppConstants = require('constants/AppConstants'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    ga = require('react-ga');

const TaskAdmin = React.createClass({displayName: "TaskAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder],

    getInitialState: function () {
        return {
            selectedItem: null,
            isEditMode: false
        };
    },

    componentDidMount: function () {
        this.fetchTask();
        ga.pageview('/task-admin');
    },

    fetchTask() {
        const self = this;
        BrewhouseStore.fetchTask(function (tasks) {
            self.setState({
                tasks
            });
        });
    },

    _onDeleteTask(task, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(t('warning'), t('process_admin_delete_confirmation'), () => {
            BrewhouseStore.deleteTask(task, onSuccess, onFailure);
        });
    },

    _onChangeTask(task, onSuccess, onFailure) {
        BrewhouseStore.changeTask(task, onSuccess, onFailure);
    },

    _onAddTask(task, onSuccess, onFailure) {
        BrewhouseStore.addTask(task, onSuccess, onFailure);
    },

    _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
        this.setState({
            selectedItem: item,
            isEditMode: !!item,
            headerActiveFilters
        }, () => {
            // stay the position of the scroll after row select when
            // the offset Y es outside of initial viewport page.
            this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
        });
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    render() {
        if (!this.state.tasks) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('process_admin_change_success'),
                changeFailureMessage: t('process_admin_change_failure'),
                deleteSuccessMessage: t('process_admin_delete_success'),
                addSuccessMessage: t('process_admin_add_success'),
                addFailureMessage: t('process_admin_failure')
            };
            const sectionMapping = AppConstants.getSectionsMapping(t);
            let contextHolder = this.getContextHolderInstance();
            let {selectedItem, tasks, isEditMode, headerActiveFilters} = this.state;
    
            const currentSelectedSection = selectedItem && selectedItem.processSection
              ? sectionMapping[selectedItem.processSection]
              : '';
    
            const currentSelectedValue = currentSelectedSection
              ? Object.assign({}, selectedItem, {displayText: currentSelectedSection})
              : selectedItem;
    
            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                  operationsHolder: contextHolder, 
                  readerAttribute: "label", 
                  isRelaxedText: true, 
                  name: t('process_admin_task_name'), 
                  value: selectedItem, 
                  label: t('process_admin_task_name'), 
                  onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupDropdown, {
                  items: AppConstants.getSections(t, 'processSection'), 
                  operationsHolder: contextHolder, 
                  readerAttribute: "displayText", 
                  customReaderWriterAttribute: "processSection", 
                  readerAttributeValue: "processSection", 
                  writerAttribute: "processSection", 
                  name: t('process_admin_section'), 
                  label: t('process_admin_section'), 
                  isImmutable: true, 
                  value: currentSelectedValue, 
                  isEditMode: isEditMode, 
                  onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                  operationsHolder: contextHolder, 
                  readerAttribute: "sequenceOrder", 
                  additionalValidation: inputValue => NumberUtils.isNumber(inputValue) ? '' : t('process_admin_error_inline_order_must_be_number'), 
                  name: t('process_admin_sequence_number'), 
                  value: selectedItem, 
                  label: t('process_admin_sequence_number'), 
                  onEnter: this._onEnterPress}
                )
            ];
    
            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('process_admin_title'), 
                        moduleName: "ADMIN_TASK", 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems:  this.fetchTask, 
                        headerFields: formFieldsEl, 
                        onAdd:  this._onAddTask, 
                        onChange:  this._onChangeTask, 
                        onCancel:  this._onCancel, 
                        onDelete:  this._onDeleteTask, 
                        addEnterKeyDown: this._addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            headerActiveFilters: headerActiveFilters, 
                            onRowSelection:  this._onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['taskSection', 'sequenceOrder'], 
                            displayAttributes:  ['label', 'displaySection', 'sequenceOrder'], 
                            filteredColumns:  ['label', 'displaySection', 'sequenceOrder'], 
                            columnNames: [
                                t('process_admin_task_name'),
                                t('process_admin_section'),
                                t('process_admin_sequence_number')
                            ]
                        }, 
                            tasks.map(task => {
                                task.displaySection = sectionMapping[task.processSection];
                                return task;
                            })
                        )
                    )
                )
            );
        }
    }
});

module.exports = TaskAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ProcessAdmin/ProcessAdmin.js
 **/